<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span v-if="items && items.length>0">اهداف کالایی {{ agentName }}</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="$q.screen.lt.md" class="text-center">
      <q-chip color="green" text-color="white"
              size="lg"
              square icon-right="attach_money" :label="lodash.sumBy(items, item=> item.Porsand).toLocaleString()"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="items"
          row-key="Goods_ID"
          wrap-cells
          flat
          :rows-per-page-options="[50]"
          :hide-header="$q.screen.lt.md">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td></td>
            <td></td>
            <td class="text-center">عنوان گروه کالا</td>
            <td class="text-center">کد کالا</td>
            <td class="text-center">عنوان کالا</td>
            <td class="text-center">تعداد تعیین شده در هدف</td>
            <td class="text-center" v-if="false">پورسانت تعیین شده</td>
            <td class="text-center">تعداد فروخته شده</td>
            <td class="text-center">تعداد برگشت داده شده</td>
            <td class="text-center">مبلغ پورسانت در صورت تحقق 100 درصد</td>
            <td class="text-center">درصد تحقق</td>
          </q-tr>
          <q-tr class="text-bold">
            <td></td>
            <td></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center" v-if="false"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center">
              <q-chip color="green" text-color="white"
                      square icon-right="attach_money"
                      :label="lodash.sumBy(items, item=> item.Porsand).toLocaleString()"/>
            </td>
            <td class="text-center"></td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center" v-if="!$q.screen.lt.md">
            <td>
              <q-avatar size="md" color="brown" text-color="white">
                {{props.row.index}}
              </q-avatar>
            </td>
            <td style="width: 90px">
              <q-btn rounded label="جزییات..." color="indigo" flat @click="showProductGoodsDetails(props.row)"/>
            </td>
            <td>
              <q-chip color="indigo" text-color="white" :label="props.row.Group_Name"/>
            </td>
            <td class="text-center">
              <q-chip color="red" square text-color="white" :label="props.row.Goods_Code" clickable
                      @click="showProductDetails(props.row)"/>
            </td>
            <td class="text-left">
              {{ props.row.Goods_Name }}
            </td>
            <td>
              <q-chip square color="deep-orange" text-color="white" :label="props.row.targetCount"/>
            </td>
            <td v-if="false">
              <q-chip square color="deep-orange" text-color="white" :label="props.row.targetCountPorsant"
                      icon-right="percent"/>
            </td>
            <td>
              <q-chip square color="green" text-color="white" :label="props.row.SaleG_Count"/>
            </td>
            <td>
              <q-chip square color="red-10" text-color="white" :label="props.row.ReturnSaleG_Count"/>
            </td>
            <td>
              <q-chip square color="green" text-color="white" :label="props.row.Porsand.toLocaleString()"/>
            </td>
            <td>
              <q-circular-progress
                  show-value
                  font-size="16px"
                  :value=" ((props.row.SaleG_Count - props.row.ReturnSaleG_Count) * 100) / props.row.targetCount"
                  size="60px"
                  :thickness="0.22"
                  color="orange"
                  track-color="orange-2"
                  :max="100"
                  :min="1">
                    <span class="text-bold">
                      {{
                        (((props.row.SaleG_Count - props.row.ReturnSaleG_Count) * 100) / props.row.targetCount) > 100 ? 100 : (((props.row.SaleG_Count - props.row.ReturnSaleG_Count) * 100) / props.row.targetCount).toFixed(2)
                      }}
                    </span>
              </q-circular-progress>
            </td>
          </q-tr>
          <q-tr :props="props" v-if="$q.screen.lt.md">
            <td>
              <q-card class="shadow-5">
                <q-card-section class="text-center">
                  <q-circular-progress
                      show-value
                      font-size="20px"
                      :value="((props.row.SaleG_Count - props.row.ReturnSaleG_Count) * 100) / props.row.targetCount"
                      size="80px"
                      :thickness="0.22"
                      color="orange"
                      track-color="orange-2"
                      :max="100"
                      :min="1">
                    <span class="text-bold">
                      {{
                        (((props.row.SaleG_Count - props.row.ReturnSaleG_Count) * 100) / props.row.targetCount) > 100 ? 100 : (((props.row.SaleG_Count - props.row.ReturnSaleG_Count) * 100) / props.row.targetCount).toFixed(2)
                      }}
                    </span>
                  </q-circular-progress>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-chip color="indigo" text-color="white" :label="props.row.Group_Name"/>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-avatar size="md" color="brown" text-color="white">
                    {{props.row.index}}
                  </q-avatar>
                  <q-chip color="red" square text-color="white" :label="props.row.Goods_Code" clickable
                          @click="showProductDetails(props.row)"/>
                  <q-space />
                  <div class="text-subtitle2">{{ props.row.Goods_Name }}</div>
                </q-card-section>
                <q-separator />

                <q-card-section class="no-padding text-center">
                  <span class="text-subtitle2">هدف</span>
                  <q-space/>
                  <q-chip square color="teal" text-color="white" label="تعداد تعیین شده در هدف">
                    <q-badge class="q-ml-xs" color="red-10" text-color="white" :label="props.row.targetCount"/>
                  </q-chip>
                  <q-chip v-if="false" icon-right="percent" square color="deep-orange" text-color="white"
                          label="پورسانت فروش">
                    <q-badge class="q-ml-xs" color="red-10" text-color="white" :label="props.row.targetCountPorsant"/>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding text-center">
                  <span class="text-subtitle2">فروش</span>
                  <q-space/>
                  <q-chip square color="green" text-color="white" label="تعداد فروش">
                    <q-badge class="q-ml-xs" color="red-10" text-color="white" :label="props.row.SaleG_Count"/>
                  </q-chip>
                  <q-chip square color="red-10" text-color="white" label="تعداد برگشت از فروش">
                    <q-badge class="q-ml-xs" color="indigo-10" text-color="white" :label="props.row.ReturnSaleG_Count"/>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding text-center">
                  <span class="text-subtitle2">پورسانت</span>
                  <q-space/>
                  <q-chip square color="green" text-color="white" :label="props.row.Porsand.toLocaleString()"/>
                </q-card-section>
                <q-card-actions align="center">
                  <q-btn rounded label="جزییات..." color="indigo" flat @click="showProductGoodsDetails(props.row)"/>
                </q-card-actions>
              </q-card>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog v-model="productInfoDialog" :maximized="$q.screen.lt.md">
      <ProductDetail :product="selectedProduct"/>
    </q-dialog>
    <q-dialog v-model="productDetailsInfoDialog" maximized>
      <TargetGoodsDetails :goods-code="selectedGoodsCode" :agent-name="agentName" :user-id="userId" :end-date="endDate"
                          :start-date="startDate"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import TargetGoodsDetails from "@/components/TargetReview/TargetGoodsDetails.vue";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "TargetGoodsInfo",
  components: {ProductDetail, TargetGoodsDetails},
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    agentName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedGoodsCode: undefined,
      productDetailsInfoDialog: false,
      selectedProduct: undefined,
      items: [],
      goodsItems: [],
      productInfoDialog: false
    }
  },
  methods: {
    ...mapActions({
      getData: 'Agents/getSummaryGoodsCommission',
      getProductInfo: 'Products/getProductInfo',
      getTargetGoodsInfo: 'Targets/getTargetGoodsInfo'
    }),
    showProductDetails(item) {
      this.getProductInfo(item.Goods_ID).then((res) => {
        this.selectedProduct = res[0]
        this.productInfoDialog = true
      })
    },
    showProductGoodsDetails(item) {
      this.selectedGoodsCode = parseInt(item.Goods_Code)
      this.productDetailsInfoDialog = true
    }
  },
  created() {
    this.getData({
      startDate: this.startDate.replaceAll('/', '-'),
      endDate: this.endDate.replaceAll('/', '-'),
      userId: this.userId
    }).then((res) => {
      this.items = res

      this.getTargetGoodsInfo({
        startDate: this.startDate.replaceAll('/', '-'),
        endDate: this.endDate.replaceAll('/', '-'),
        userId: this.userId
      }).then((res) => {
        res.forEach(rec=>{
         if (this.items.findIndex(item=> item.Goods_ID === rec.Goods_ID) === -1){
           rec.Porsand = 0
           rec.SaleG_Count = 0
           rec.ReturnSaleG_Count = 0
           this.items.push(rec)
         }
        })
        this.items= this.lodash.orderBy(this.items, item=> ((item.SaleG_Count - item.ReturnSaleG_Count) * 100) / item.targetCount, 'desc')
        let i = 1;
        this.items.forEach(rec=> rec.index = i++)
      })
    })
  }
}
</script>

<style scoped>

</style>